var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89833 0C7.52712 0 9.00149 0.660158 10.0689 1.72754C11.1363 2.79493 11.7964 4.26942 11.7964 5.89821C11.7964 7.46181 11.188 8.88296 10.1952 9.93851C10.2133 9.95181 10.2307 9.96658 10.2472 9.98294L14.4935 14.2233C14.6713 14.4002 14.6723 14.688 14.4952 14.866C14.3183 15.044 14.0304 15.0447 13.8526 14.8678L9.60635 10.6275C9.57937 10.6006 9.55655 10.5713 9.53763 10.5402C8.53506 11.3272 7.27151 11.7965 5.89821 11.7965C4.26942 11.7965 2.79481 11.1364 1.72742 10.069C0.660158 9.00161 0 7.527 0 5.89821C0 4.26942 0.660158 2.79493 1.72754 1.72754C2.79493 0.66028 4.26954 0 5.89833 0ZM9.40945 2.38709C8.51089 1.48853 7.26955 0.932742 5.89833 0.932742C4.52711 0.932742 3.28565 1.48853 2.38709 2.38709C1.48853 3.28565 0.932742 4.52699 0.932742 5.89821C0.932742 7.26943 1.48853 8.51089 2.38709 9.40945C3.28553 10.308 4.52699 10.8638 5.89833 10.8638C7.26955 10.8638 8.51089 10.308 9.40945 9.40945C10.308 8.51101 10.8638 7.26955 10.8638 5.89821C10.8638 4.52699 10.308 3.28565 9.40945 2.38709Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.19d1eab6f0861a91ddbaa5be239796c9.svg";
export { ForwardRef as ReactComponent };